<template>
  <UApp>
      <NuxtLayout :name="layout()">
        <NuxtPage />
      </NuxtLayout>
      <ConfirmationDialog />
  </UApp>
</template>
<script setup lang="ts">

  useSeoMeta({
    title: 'SpreadIt',
    ogTitle: 'SupaNuxt SaaS',
    ogUrl: 'https://nuxt3-saas-boilerplate.netlify.app/',
    ogType: 'website',
    // fbAppId: '1111222233334444', // you will need this if you authenticate with fb
    description:
      'With SupaNuxt SaaS, you can easily get started building your next web application. Our pre-configured tech stack and industry leading features make it easy to get up and running in no time.',
    ogDescription:
      'With SupaNuxt SaaS, you can easily get started building your next web application. Our pre-configured tech stack and industry leading features make it easy to get up and running in no time.',
    ogImage:
      'https://nuxt3-saas-boilerplate.netlify.app/_nuxt/supanuxt_logo_200.896c0d73.png',
    twitterCard: 'summary_large_image'
  });
  // Auth state managed by @sidebase/nuxt-auth via useAuth()
  const route = useRoute()
  function layout() {
    const path = route?.path
    if (route?.path?.startsWith('/app')) {
      return 'app-wide'
    }else if (route?.path?.startsWith('/public/surveyform')) {
      return 'island'
    }
    else if (route?.path?.startsWith('/public')) {
      return 'default-layout'
    }
    else if (route?.path?.startsWith('/assets')) {
      return 'app'
    }
    else {
      return 'default-layout'
    }
  }
  // const website = useWebsiteStore()
  // await callOnce(website.fetch)
</script>
